import Vue from "vue";
import Url from "../../utils/url.js";
import HappeningFilterForm from "./happening-filter-form";
import { optionGroups } from "./options";
import { defineCustomElements } from "@duetds/date-picker/dist/loader";

document.addEventListener("DOMContentLoaded", () => {
  const el = document.querySelector("[data-happening-filter-form]");
  const defaultHappeningType = optionGroups.reduce((arr, group) => arr.concat(group.options), [])[0].value;
  const initialHappeningType = Url.getParam("happening_filter") || defaultHappeningType;
  const initialDate = Url.getParam('date') ? new Date(`${Url.getParam('date')}T00:00:00-05:00`) : new Date();

  initialDate.setHours(0, 0, 0, 0);
  Vue.config.ignoredElements = [/duet-\w*/];
  defineCustomElements(window);

  new Vue({
    el: el,
    components: { HappeningFilterForm },
    data: {
      id: "calendar-happening-filter-form",
      dateRaw: initialDate,
      option: initialHappeningType,
      optionGroups: optionGroups,
    },
    template: `
      <HappeningFilterForm
        :id=id
        :dateRaw=dateRaw
        :option=option
        :optionGroups=optionGroups
      />
    `,
  });
});
